import React from "react";
import { Typography, Box } from "@mui/material";

const Home = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="body1">Selecciona una opción del menú.</Typography>
  </Box>
);

export default Home;
